import { gql } from '@apollo/client';

const getBookingConsumerByID = gql`
  query GetConsumerByID($getConsumerById: ID!) {
    getConsumerByID(id: $getConsumerById) {
      linkedAccounts {
        membershipID
        membershipType
        provider
        updatedAt
        id
        createdAt
        analytics
        externalID
        memberships {
          id
          membershipNumber
        }
        sourceCode
      }
      memberships {
        membershipStatus
        linkedAccount {
          id
        }
        # uncomment if needed
        # dealEntitlements {
        #   id
        #   redeemableTags {
        #     accessType
        #     category
        #     isoCountryCode
        #     locationType
        #     outletTier
        #     tier
        #     programme
        #   }
        #   externalID
        #   externalMembershipPlanID
        #   dealEntitlementName
        #   isActive
        #   startDate
        #   endDate
        #   expired
        #   perVisitLimit
        #   isUnlimited
        #   beneficiary
        #   createdAt
        #   updatedAt
        #   renewalFrequency
        #   usedEntitlementCount
        #   remainingEntitlementCount
        # }
        createdAt
        id
        externalID
        membershipNumber
        membershipPlan {
          id
          ica
          issuer
          planName
          programme
          externalID
          createdAt
          updatedAt
          status
          startDate
          endDate
          membershipNoLength
          membershipPrefix
        }
      }
      firstName
      lastName
      dateOfBirth
      createdAt
      emailAddress
      id
      updatedAt
      locale
    }
  }
`;

export default getBookingConsumerByID;
